import React from "react";
import { ClipboardList } from "lucide-react";
import { useTranslation } from "react-i18next";
import DeploymentList from "./DeploymentList/DeploymentList";


const ResourceAssignAndDeploy = () => {
  const { t } = useTranslation();

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 14px",
            borderRadius: "10px",
            background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
            boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "8px",
              background: "rgba(255,255,255,0.16)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <ClipboardList size={14} color="#fff" />
          </div>
          <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
            {t("resource_assign_list")}
          </div>
        </div>
        <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px" }}>
          <DeploymentList />
        </div>
      </div>
    </>
  );
};

export default ResourceAssignAndDeploy;
